import { createAction } from '@reduxjs/toolkit';

export const setChanges = createAction('setChanges');
export const resetChanges = createAction('resetChanges');
export const setMissingVariants = createAction('setMissingVariants');
export const clearMissingVariants = createAction('clearMissingVariants');
